interface LogoProps {
  className?: string;
}

export const Logo = ({ className = "h-6 w-6" }: LogoProps) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      {/* Modern AI-focused logo for Vettor */}
      <path 
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" 
        fill="#1E3A8A" 
        opacity="0.1"
      />
      <path 
        d="M12 4C7.582 4 4 7.582 4 12C4 16.418 7.582 20 12 20C16.418 20 20 16.418 20 12C20 7.582 16.418 4 12 4Z" 
        fill="#1E3A8A" 
        opacity="0.2"
      />
      {/* V shape */}
      <path 
        d="M14.5 7L12 11.5L9.5 7H6.5L12 17L17.5 7H14.5Z" 
        fill="#1E3A8A" 
      />
      {/* AI Node connections */}
      <circle cx="12" cy="11.5" r="1.5" fill="#1E3A8A" />
      <circle cx="9.5" cy="7" r="1" fill="#1E3A8A" />
      <circle cx="14.5" cy="7" r="1" fill="#1E3A8A" />
      <circle cx="17.5" cy="7" r="1" fill="#1E3A8A" />
      <circle cx="6.5" cy="7" r="1" fill="#1E3A8A" />
    </svg>
  );
};
